import React from "react";
import logoimg from "images/logo.png"

const Logo = () => (
	<img src={logoimg} height="50" alt="" />
);

export default Logo;
